import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { fetchCaissierTerminal, formatTerminalOptionLabel } from '../../services/posService';
import CashierSidebar from '../../components/cashier/CashierSidebar';
import CashierHeader from '../../components/cashier/CashierHeader';
import CashReport from '../../components/reports/CashReport';

/** Rapport de caisse du caissier : uniquement ses propres encaissements. */
const CashierReportsPage = () => {
    const { selectedOrganization, user } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [caissierTerminal, setCaissierTerminal] = useState(null);

    useEffect(() => {
        if (!selectedOrganization?.id || !user?.id) return;
        fetchCaissierTerminal(selectedOrganization.id, user.id)
            .then((terminal) => setCaissierTerminal(terminal || null))
            .catch(() => setCaissierTerminal(null));
    }, [selectedOrganization?.id, user?.id]);

    const cashierName = user?.profile?.completeName || user?.name || user?.phone?.fullNumber || 'Caissier';
    const scopeLabel = `${caissierTerminal ? `${formatTerminalOptionLabel(caissierTerminal)} · ` : ''}${cashierName}`;

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-amber-50/20 to-slate-50 flex">
            <CashierSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />

            <div className="flex-1 min-h-screen transition-all duration-300 overflow-hidden flex flex-col lg:ml-[var(--cashier-sidebar-w,18rem)] transition-[margin] duration-300">
                <CashierHeader onMenuToggle={() => setSidebarOpen(!sidebarOpen)} terminal={caissierTerminal} />

                <div className="flex-1 p-5 lg:p-8 overflow-y-auto">
                    <CashReport
                        organization={selectedOrganization}
                        cashierId={user?.id}
                        cashierNameById={user?.id ? { [user.id]: cashierName } : {}}
                        scopeLabel={scopeLabel}
                    />
                </div>
            </div>
        </div>
    );
};

export default CashierReportsPage;
